import API from "../components/helpers/endpointservice";
import Actions from './api';
export const AllGroups = (data) => {
  return (dispatch) => {
    

    return new Promise((resolve, reject) => {
      dispatch({ type: "IS_LOADER", data: true });
      const params = new URLSearchParams();
      if (data) {
        if (data.groupName) params.append('GroupName', data.groupName);
        if (data.sortBy) params.append('SortBy', data.sortBy);
        if (data.sortByOrder) params.append('SortOrder', data.sortByOrder);
        if (data.PageNumber) params.append('PageNumber', data.PageNumber);
        if (data.PageSize) params.append('PageSize', data.PageSize);
      }

      // Perform the API request
      Actions.GET(`${API.ALL_GROUPS}${params.toString() ? `?${params.toString()}` : ''}`)
        .then((res) => {
          if (res.data !== undefined) {
            dispatch({ type: "IS_LOADER", data: false });
            resolve(res.data);
          } else {
            dispatch({ type: "IS_LOADER", data: false });
            reject(new Error("No data in response"));
          }
        })
        .catch((error) => {
          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};


// export const AssignedMembers = (groupId,data) => {
//   
//   return (dispatch) => {
//     return new Promise((resolve, reject) => {
//       //Loader true
//       dispatch({ type: "IS_LOADER", data: true });
//       Actions.GET(`${API.ASSIGNED_MEMBERS}/${groupId}/assignedmembers?Name=${data?.Name?data?.Name:""}&Email=${data?.Email?data?.Email:""}&SortBy=${data?.SortBy?data.SortBy:""}&SortOrder=${data?.SortOrder?data?.SortOrder:""}&PageNumber=${data?.PageNumber?data?.PageNumber:''}&PageSize=${data?.PageSize?data?.PageSize:""}`).then((res) => {
//         if (res.data !== undefined) {
//           resolve(res.data);
//           dispatch({ type: "IS_LOADER", data: false });
//           return res.data

//         }
//         else {
//           reject(new Error("No data in response"));
//           dispatch({ type: "IS_LOADER", data: false });

//         }
//         //Loader false

//       }).catch((error) => {
//         //Loader false
//         dispatch({ type: "IS_LOADER", data: false });
//         reject(error)
//       });
//     });
//   };
// }

export const AssignedMembers = (groupId, data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      // Show loader
      dispatch({ type: "TABLE_LOADER", data: true });

      // Construct query string using URLSearchParams
      const params = new URLSearchParams();

      // Conditionally append parameters if they exist
      if (data) {
        if (data.Name) params.append('Name', data.Name);
        if (data.Email) params.append('Email', data.Email);
        if (data.SortBy) params.append('SortBy', data.SortBy);
        if (data.SortOrder) params.append('SortOrder', data.SortOrder);
        if (data.PageNumber) params.append('PageNumber', data.PageNumber);
        if (data.PageSize) params.append('PageSize', data.PageSize);
      }

      // Perform the API request
      Actions.GET(`${API.ASSIGNED_MEMBERS}/${groupId}/assignedmembers${params.toString() ? `?${params.toString()}` : ''}`)
        .then((res) => {
          if (res.data !== undefined) {
            dispatch({ type: "TABLE_LOADER", data: false });
            resolve(res.data);
          } else {
            dispatch({ type: "TABLE_LOADER", data: false });
            reject(new Error("No data in response"));
          }
        })
        .catch((error) => {
          dispatch({ type: "IS_LOADER", data: false });
          reject(error);
        });
    });
  };
};


export const UnAssignedMembers = (groupId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "TABLE_LOADER", data: true });
      Actions.GET(`${API.ASSIGNED_MEMBERS}/${groupId}/unassignedmembers`).then((res) => {
        if (res.data !== undefined) {
          resolve(res.data);
          dispatch({ type: "TABLE_LOADER", data: false });
          return res.data

        }
        else {
          reject(new Error("No data in response"));
          dispatch({ type: "TABLE_LOADER", data: false });

        }
        //Loader false

      }).catch((error) => {
        //Loader false
        dispatch({ type: "TABLE_LOADER", data: false });
        reject(error)
      });
    });
  };
}


export const AddGroup = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      Actions.POST(`${API.NEW_GROUP}`, data).then((res) => {
        if (res.data !== undefined) {

          resolve(res.data);
          dispatch({ type: "IS_LOADER", data: false });
        }
        else {
          reject(new Error("No data in response"));
          dispatch({ type: "IS_LOADER", data: false });
        }

      })
        .catch((error) => {
          dispatch({ type: "IS_LOADER", data: false });
          reject(error)
        });
    });
  };
};


export const AddMemberInGroup = (groupid, data) => {

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "TABLE_LOADER", data: true });
      Actions.POST(`${API.ADD_MEMBER_GROUP}/${groupid}/member`, data).then((res) => {
        if (res.data !== undefined) {

          resolve(res.data);
          dispatch({ type: "TABLE_LOADER", data: false });
        }
        else {
          reject(new Error("No data in response"));
          dispatch({ type: "TABLE_LOADER", data: false });
        }

      })
        .catch((error) => {
          dispatch({ type: "TABLE_LOADER", data: false });
          reject(error)
        });
    });
  };
};


export const DeleteMemberFromGroup = (data, groupId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      Actions.DELETE(`${API.DELETE_MEMBER_GROUP}/${groupId}/member`, data).then((res) => {
        if (res.data !== undefined) {
          // dispatch({ type: "ROLE_USER_DELETED_SUCCESS", data: {} });

          resolve(res.data);
        }
        else {
          reject(new Error("No data in response"));
        }
        //Loader false
        dispatch({ type: "IS_LOADER", data: false });
        dispatch({ type: "TABLE_LOADER", data: false });
      })
        .catch((error) => {
          console.log("error", error)
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          dispatch({ type: "TABLE_LOADER", data: false });
          reject(error)
        });
    });
  };
};


export const DeleteGroup = (groupId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      Actions.DELETE(`${API.DELETE_GROUP}/${groupId}`).then((res) => {
        if (res.data !== undefined) {
          // dispatch({ type: "ROLE_USER_DELETED_SUCCESS", data: {} });

          resolve(res.data);
        }
        else {
          reject(new Error("No data in response"));
        }
        //Loader false
        dispatch({ type: "IS_LOADER", data: false });
      })
        .catch((error) => {
          console.log("error", error)
          //Loader false
          dispatch({ type: "IS_LOADER", data: false });
          reject(error)
        });
    });
  };
};





export const GroupEdit = (groupId, data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      //Loader true
      dispatch({ type: "IS_LOADER", data: true });
      Actions.PUT(`${API.EDIT_GROUP}/${groupId}`, data).then((res) => {
        if (res.data !== undefined) {
          resolve(res.data);
          dispatch({ type: "IS_LOADER", data: false });
        }
        else {
          dispatch({ type: "IS_LOADER", data: false });
          reject(new Error("No data in response"));
        }
        //Loader false
        dispatch({ type: "IS_LOADER", data: false });
      })
        .catch((error) => {
          dispatch({ type: "IS_LOADER", data: false });
          console.log("error", error)
          //Loader false
          // dispatch({ type: "IS_LOADER", data: error });
          reject(error)
        });
    });
  };
}